<template>
<div>

<template v-if="$store.state.auth.userroles.includes('supplier')">
<ContentHeader v-if="data"  :title="flowname"  :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don" url="SupplierProjectDetail" :urlparams="headerurlparams"></ContentHeader>
</template>

<template v-else>


<div class="contenttopbar grid px-3 mt-1" v-if="data">
<div class="col-8 ">
<h3 class="text-primary mb-3 mt-3 font-medium">{{flowname}}</h3>
</div>

<div class="col-4 ">

<div class="flex align-items-center justify-content-end">

<div class="hide_on_mobile mr-2"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.asama_gecmisi" icon="pi pi-history" @click="showHistory" /></div>
<div class="show_on_mobile mr-2"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" icon="pi pi-history" @click="showHistory" /></div>

<div class="hide_on_mobile "><Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.geri_don" icon="pi pi-arrow-left" @click="goBack" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" icon="pi pi-arrow-left" @click="goBack" /></div>



</div>
</div>
</div>





</template>


<div class="content_card" >
<div class="grid">
<div class="col-12">
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">

<div class="grid">

<div class="col-12 md:col-5 pb-0">
<h4 class="text-primary mt-0">{{$store.state.languages.lang_phrases.asama_ozeti}}</h4>


<template v-if="data.flowsupplier.flow.type=='education'">

<p class="text-red-600 font-bold" v-if="data.flowsupplier.status !=='finished'">{{$store.state.languages.lang_phrases.asama_henuz_tamamlanmadi}}</p>
<p class="text-green-600 font-bold" v-else>{{$store.state.languages.lang_phrases.asama_tamamlandi}}</p>

</template>


<template v-else>



    <template v-if="data.quizresult">
      <template v-if="data.flowsupplier.status=='finished' || data.flowsupplier.status=='under_review'">
        
      


    <div class="grid" id="quizresult_wrap" v-if="data.quizresult.questionlist && data.quizresult.questionlist.calculate_points">

    <template v-if="!data.quizresult.questionlist.only_percentage">

      <div class="col-3">
      <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.puan}}:</p>
      </div>

      <div class="col-9">
      <p class=" mt-0">
      <span class="text-green-500 font-bold">{{data.quizresult.percentage_over_points}} / {{data.quizresult.points.toFixed(2)}}</span>
      </p>
      </div>
      
    </template>

    


    <div class="col-3">
    <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.basari_yuzdesi}}:</p>
    </div>

    <div class="col-9">
    <p class=" mt-0">
    <span class="text-primary  font-bold">{{data.quizresult.percentage}}%</span>
    </p>
    </div>
    <template v-if="data.flowsupplier.flow.calculationattribute">
    <div class="col-3">
    <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.basari_durumu}}:</p>
    </div>

    <div class="col-9">
      <template v-if="data.flowsupplier.flow.calculationattribute.type=='select'">
        <p class="mt-0 font-bold" v-html="calculationAttributeVersion"></p>
      </template>
    </div>
      
    </template>
    <template v-if="data.flowsupplier.flow.type=='audit' && data.flowsupplier.audit && data.flowsupplier.audit.status=='exempt'">
    <div class="col-12">
    <p class="font-bold mt-0 text-green-600">{{$store.state.languages.lang_phrases.tedarikci_bu_asamadan_muaf_tutuldu}}</p>
    </div>
    </template>
    <!-- audit nonconformities -->
    <template v-if="data.flowsupplier.flow.type=='audit' && data.flowsupplier.audit && data.flowsupplier.audit.status!=='exempt' && data.nonconformities.length">
      <div class="col-3">
        <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.uygunsuzluklar}}:</p>
      </div>
      <div class="col-9">
          <SupplierProjectFlowSummaryNonconformityNode   
          v-for="(type,i) in data.nonconformity_types"        
          :nonconformities="data.nonconformities"
          :type="type"
          @gotoActionPlan="gotoActionPlan"
          /> 
      </div>

    </template>
    <!-- audit nonconformities -->
    <!-- verification nonconformities -->
    <template v-if="data.flowsupplier.flow.type=='verification' && data.flowsupplier.verification && data.flowsupplier.verification.status=='finished' && data.nonconformities.length">
      <div class="col-3">
        <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.uygunsuzluklar}}:</p>
      </div>
      <div class="col-9">
          <SupplierProjectFlowSummaryNonconformityNode   
          v-for="(type,i) in data.nonconformity_types"        
          :nonconformities="data.nonconformities"
          :type="type"
          /> 
      </div>

    </template>
    <!-- verification nonconformities -->

    



    </div>
    <div class="grid" v-else>
    <div class="col-12">
    <p class="text-green-500 font-bold mt-0">{{$store.state.languages.lang_phrases.bu_asama_icin_puanlama_bulunmuyor}}</p>
    </div>
    </div>




    </template>



    </template>

    <template v-else>
      <p class="text-red-600 font-bold">{{$store.state.languages.lang_phrases.asama_henuz_tamamlanmadi}}</p>
    </template>




</template>





</div>





<div class="col-12 md:col-7 mt-1 pb-0">



<div class="flex align-items-center justify-content-end ">


<!--<Button label="indir"  class="p-button-info  p-button-sm rightmargin mt-4 mr-2" @click="generateImage" ></Button>-->


<Button 
:label="$store.state.languages.lang_phrases.isaretleme_raporu"  
class="p-button-info  p-button-sm rightmargin mt-4 mr-2" 
@click="downloadExcel" v-if="data.flowsupplier.status=='finished' && data.flowsupplier.flow.type !=='education'" :loading="downloading_excel"></Button>

<Button 
:label="$store.state.languages.lang_phrases.bolum_analizi"  
class="p-button-success  p-button-sm rightmargin mt-4 mr-2" 
@click="goToAnalysis" 
v-if="data.flowsupplier.status=='finished'" 
:loading="recalculating" >  
</Button>




<!-- calculation buttons -->
<template v-if="data.quizresult && data.quizresult.requires_recalculation">
<Button 
:label="$store.state.languages.lang_phrases.tekrar_hesaplama_gerekli"  
class="p-button-danger  p-button-sm rightmargin mt-4 mr-2" 
@click="recalculate(data.flowsupplier.uuid)" 
v-if="data.flowsupplier.status=='finished' && data.quizresult.questionlist.calculate_points" 
:loading="recalculating" >  
</Button>
</template>

<template v-else>
<Button 
:label="$store.state.languages.lang_phrases.tekrar_hesapla"  
class="p-button-help  p-button-sm rightmargin mt-4 mr-2" 
@click="recalculate(data.flowsupplier.uuid)" 
v-if="data.flowsupplier.status=='finished' && data.flowsupplier.flow.type !=='education' && data.quizresult && data.quizresult.questionlist.calculate_points" 
:loading="recalculating">  
</Button> 

<Button 
:label="$store.state.languages.lang_phrases.hesaplama"  
class="p-button-help  p-button-sm rightmargin mt-4 mr-2" 
@click="recalculate(data.flowsupplier.uuid)" 
v-if="data.flowsupplier.status=='finished' && data.flowsupplier.flow.type !=='education' && !data.quizresult" 
:loading="recalculating">  
</Button> 


</template>

<!-- calculation buttons -->


<Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin mt-4" @click="gotoActiveFlow(data.flowsupplier.uuid)" ></Button>
</div>



</div>


<template v-if="data.quizresult &&data.quizresult.questionlist.multiple_calculations && data.flowsupplier.customquizresults.length">
    <div class="col-12">
      <hr>
      <h4 class="text-primary">{{$store.state.languages.lang_phrases.soru_sinifi_hesaplamalari}}</h4>
    </div>
      <div class="col-12">
        <Accordion multiple>
          <AccordionTab v-for="result in data.flowsupplier.customquizresults" :header="result.calculation.name">
            <div class="grid" >
              <div class="col-2">
              <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.puan}}:</p>
              </div>
              <div class="col-10">
                <p class="text-primary mt-0">{{result.points.toFixed(2)}}</p>
              </div>
              <template v-if="result.calculation.customattribute && result.calculation.customattribute.supplierattributes.length">
                <div class="col-2">
                <p class="font-bold mt-0">{{getTheTranslation(result.calculation.customattribute,"translation")}}:</p>
                </div>
                <div class="col-10">
                  <template v-if="result.calculation.customattribute.type=='select'">
                    <p class="mt-0 font-bold" v-html="getOptionData(result.calculation.customattribute.options,result.calculation.customattribute.supplierattributes[0].attibutenumericalval)"></p>
                  </template>
                </div>          
              </template>
            </div>
        </AccordionTab>
        </Accordion>
      </div>      
    </template>

<!--
<div class="col-12">
  <hr>
<div class="grid"  v-for="item in flowsupplierattributes">
<div class="col-4"><p class="click_edit_value_title">{{item.customattribute.name}}:</p></div>
<div class="col-8"><p class="click_edit_value">-</p></div>

</div>
</div>
-->

<div class="col-12" v-if="data.flowsupplier.status=='correction_requested'">
 <hr>
<h4 class="text-red-500 ">{{$store.state.languages.lang_phrases.duzeltme_talep_edildi}}</h4>

<template v-if="data.flowsupplier.correctionrequest">
<address>{{data.flowsupplier.correctionrequest.reason}}</address>
</template>
</div>




<SupplierProjectFlowSummaryForAttributes  :flowsupplierattributes="flowsupplierattributes" />





</div>
<!--
<SupplierProjectFlowSummaryForAudit 
v-if="data.flowsupplier.flow.type=='audit'"
:requiredcertificates="requiredcertificates" 
:exemptioncertificates="exemptioncertificates" 
:flowsupplier="data.flowsupplier"
@documentUpdated="documentUpdated"
></SupplierProjectFlowSummaryForAudit>
-->

<SupplierProjectFlowSummaryForVerification 
v-if="data.flowsupplier.flow.type=='verification'"
:flowsupplier="data.flowsupplier"
:nonconformities="nonconformities"
:nonconformity_types="nonconformity_types"
></SupplierProjectFlowSummaryForVerification>


</div>



</div>
</div>
</div>

<div id="pdf_content" class="hidden" ref="testHtml">

<h1></h1>
</div>

<Sidebar v-model:visible="historysidebar" header="Sidebar" position="right" class="w-full md:w-30rem lg:w-30rem">
<div class="grid">
<div class="col-6"><h3 class="text-primary ">{{$store.state.languages.lang_phrases.asama_gecmisi}}</h3></div>
<div class="col-6 flex justify-content-end align-items-center">
<Button type="button"  icon="pi pi-times" :label="$store.state.languages.lang_phrases.iptal" class="p-button-danger p-button-outlined p-button-sm mr-2"  @click="close"/> 
</div>

</div>
<hr>
<template v-if="loading_history">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>
<ScrollPanel style="width: 100%; height: 80vh">
<div class="grid" v-for="item in flowsupplier_history">
<div class="col-4">
  <template v-if="item.user">
    <small class="text-primary" v-tooltip.left="{ value: item.user.email, disabled: false,class: 'custom-top-tooltip' }"><b> {{item.user.name}}</b></small>
  </template>
  <template v-else>
    <small class="text-primary"><b> System</b></small>
  </template>

</div>
<div class="col-4">
<small class="text-purple-500"><b>{{ $filters.momentFormat( item.created_at," Do-MM-YYYY HH:mm")}}</b></small>
</div>
<div class="col-4">
<Tag 
class="ml-2   custom-chip" 
:value="getHistoryItemTag(item).name" 
:style="'background-color:'+getHistoryItemTag(item).color"
/>
</div>

<div class="col-12">
<hr>
</div>

</div>
</ScrollPanel>

  
</template>


</Sidebar>


</div>


</template>

<script>
import domtoimage from 'dom-to-image';
import { jsPDF } from "jspdf";
import { PDFDocument } from 'pdf-lib'
import * as XLSX from 'xlsx/xlsx.mjs'
import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import SupplierProjectFlowSummaryForAudit  from "./SupplierProjectFlowSummaryForAudit"
import SupplierProjectFlowSummaryForEducation  from "./SupplierProjectFlowSummaryForEducation"
import SupplierProjectFlowSummaryForSelfEvaluation  from "./SupplierProjectFlowSummaryForSelfEvaluation"
import SupplierProjectFlowSummaryForVerification  from "./SupplierProjectFlowSummaryForVerification"
import SupplierProjectFlowSummaryForAttributes  from "./SupplierProjectFlowSummaryForAttributes"
import SupplierProjectFlowSummaryNonconformityNode  from "./SupplierProjectFlowSummaryNonconformityNode"


import moment from "moment"
export default {

  name: 'SupplierProjectFlowSummary',

  data () {
    return {
    	data:null,
      historysidebar:false,
      loading_history:true,
      flowsupplier_history:[],
    	loading:true,
      recalculating:false,
      downloading_excel:false,
      requiredcertificates:[],
      exemptioncertificates:[],
      nonconformities:[],
      nonconformity_types:[],
      audit_inputfields_data:null,
      workbook:null,
      worksheet:null,
      activerow:1,
      questionlist_options:[],
    }
  },
  components:{
    SupplierProjectFlowSummaryForAudit,
    SupplierProjectFlowSummaryForEducation,
    SupplierProjectFlowSummaryForSelfEvaluation,
    SupplierProjectFlowSummaryForVerification,
    SupplierProjectFlowSummaryForAttributes,
    SupplierProjectFlowSummaryNonconformityNode,
  },
  computed:{
    calculationAttributeVersion()
    {
      
      let result
      let calculationattribute = this.data.flowsupplier.flow.calculationattribute
      let options = calculationattribute.options
      let versions = this.data.flowsupplier.supplierattributeversions
      let sup_attribute = this.data.flowsupplier.flow.calculationattribute.supplierattributes[0]

      
      if(versions.length && sup_attribute && sup_attribute.attibutenumericalval)
      {
        let version = versions.find(item=>item.customattribute_id == sup_attribute.customattribute_id)
        if(version)
        {
          
          let option = options.find(item=>item.id == version.attibutenumericalval)
          if(option)
          {
            if(option.color)
            {
              result = "<span style='color:#"+option.color+"'>"+this.getTheTranslation(option,"translation")+"</span>"
            }
            else
            {
              result = "<span class='text-primary'>"+this.getTheTranslation(option,"translation")+"</span>"
            }
          }

        }
      }
      else
      {
        result = this.getOptionData(options,sup_attribute.attibutenumericalval)
      }
      console.log(result)
      return result
    },
    flowsupplierattributes()
    {
      if(this.data.flowsupplier && this.data.flowsupplier.flow.flowattributes.length)
      {
        let result = []
        for(let item of this.data.flowsupplier.flow.flowattributes)
        {
          let custom_attribute_id = item.customattribute_id
          let ind = this.data.flowsupplier.supplierattributeversions.findIndex(element =>element.customattribute_id == custom_attribute_id)
          if(ind!==-1)
          {            
            item.customattribute.supplierattributes[0].attibutenumericalval = this.data.flowsupplier.supplierattributeversions[ind].attibutenumericalval
            item.customattribute.supplierattributes[0].attibutetextval = this.data.flowsupplier.supplierattributeversions[ind].attibutetextval
          }
          
          result.push(item)
        }
        return result
      }
      return []
    },
    headerurlparams()
    {
      return {project_id:this.$route.params.project_id}
    },
    flowname()
    {
      let flowname
      if(this.data && this.data.flowsupplier && this.data.flowsupplier.flow)
      {        
        flowname= this.getTheTranslation(this.data.flowsupplier.flow,"translation")
        if(this.data.flowsupplier.projectperiod)
        {
          flowname = flowname+" - "+this.data.flowsupplier.projectperiod.name
        }
        return flowname
      }
      return flowname
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"projeler") 
    this.loading = true
  	this.getData()
  },
  methods:{
    gotoActionPlan()
    {
      this.$router.push({ name: 'AuditActionPlan', params: { audit_uuid:this.data.flowsupplier.audit.uuid } })
    },
    close()
    {
      this.historysidebar = false
    },
    generateImage()
    {
      domtoimage.toJpeg(document.getElementById('quizresult_wrap'), { quality: 0.95 })
      .then(function (dataUrl) {
          var link = document.createElement('a');
          link.download = 'my-image-name.jpeg';
          link.href = dataUrl;
          link.click();
      });
    },
    getOptionData(options,id)
    {
      let item = options.find(item=>item.id == id)
      if(item)
      {
        if(item.color)
        {
          return "<span style='color:#"+item.color+"'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
        else
        {
          return "<span class='text-primary'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
      }
      return null
    },
    goToAnalysis()
    {
      this.$router.push({ name: 'SupplierProjectFlowSummaryAnalysis', params: { project_id:this.$route.params.project_id,flow_id:this.$route.params.flow_id } })
    },
    getHistoryItemTag(item)
    {
      let name
      let color
      if(item.status=="created")
      {
        name =  this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(item.status=="viewed")
      {
        name =  this.$store.state.languages.lang_phrases.goruntulendi
      }
      if(item.status=="started")
      {
        name =  this.$store.state.languages.lang_phrases.baslandi
      }

      if(item.status=="deleted")
      {
        name =  this.$store.state.languages.lang_phrases.silindi
      }
      if(item.status=="finished")
      {
        name =  this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(item.status=="under_review")
      {
        name =  this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(item.status=="canceled")
      {
        name =  this.$store.state.languages.lang_phrases.iptal_edildi
      }
      if(item.status=="correction_requested")
      {
        name =  this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede
      }
      if(item.status=="recalculated")
      {
        name =  this.$store.state.languages.lang_phrases.tekrar_hesaplandi
      }

      if(item.status=="created")
      {
        color =  "#352f8d"
      }
      if(item.status=="viewed")
      {
        color = "#7e2f8d"
      }
      if(item.status=="started")
      {
        color = "#dd4b39"
      }
      if(item.status=="deleted")
      {
        color = "#dd4b39"
      }
      if(item.status=="finished")
      {
        color = "#4dc247"
      }
      if(item.status=="under_review")
      {
        color = "#ff6600"
      }
      if(item.status=="canceled")
      {
        color = "#a82400"
      }
      if(item.status=="correction_requested")
      {
        color = "#3b82f6"
      }
      if(item.status=="recalculated")
      {
        color = "#3b82f6"
      }

      return {
        name:name,
        color:color
      }

    },
    async showHistory()
    {
      
      this.historysidebar = true
      this.loading_history = true

      console.log(this.$route.params.flow_id)      

      this.flowsupplier_history = await this.generalApiGetWithoutLoader("audit/get_flowsupplier_history/"+this.$route.params.flow_id) 
      console.log(this.flowsupplier_history)
      this.loading_history = false
    },
    goBack()
    {
      let url_params = {project_id:this.$route.params.project_id}
      this.$router.push({ name:  "SupplierProject", params: url_params }) 
    },
    downloadExcel()
    {
      let type = this.data.flowsupplier.flow.type
      if(type=="self_evaluation"|| type=="verification")
      {
        this.downloadSelfEval()
      }
      if(type=="audit")
      {        
        this.downloadAudit()
      }
    },
    async downloadAudit()
    {
      this.downloading_excel = true
      await this.downloadAuditMarkingReport(this.data)       
      this.downloading_excel = false
    },    
    async downloadSelfEval()
    {
      this.downloading_excel = true
      await this.downloadSelfEvalMarkingReport(this.data)      
      this.downloading_excel = false

    },    
    async  pdfoUTPUT()
    {      
      var doc = new jsPDF('p', 'pt', 'A4');
      let  margins = {
            top: 80,
            bottom: 60,
            left: 40,
            width: 522
        };
      doc.html(this.$refs.testHtml, {
         callback: function (doc) {
           doc.save();
         },
         x: 10,
         y: 10
      });
      

    },
    async recalculate(flowsupplier_uuid)
    {
      this.recalculating = await true
      let data = await this.generalApiGetWithoutLoader("audit/recalculate_flowsupplier_data/"+flowsupplier_uuid)
      console.log(data)
      //this.data.quizresult = await data
      this.getData()
      this.recalculating = await false
    },
    documentUpdated(data)
    {
      this.data.uploaded_certificates = data
      this.resolveUploadedCertificates()
      
    },
    resolveUploadedCertificates()
    {
      let uploaded_certificates = this.data.uploaded_certificates
      let requiredcertificates = this.requiredcertificates
      let exemptioncertificates = this.exemptioncertificates


      for(let requiredcertificate of requiredcertificates)
      {
        requiredcertificate.documents = []
        requiredcertificate.upload_status = 0
      }

      for(let exemptioncertificate of exemptioncertificates)
      {
        exemptioncertificate.documents = []
        exemptioncertificate.upload_status = 0
      }

      for(let uploaded_certificate of uploaded_certificates)
      {
        let exampmatch = exemptioncertificates.findIndex((item)=>{return item.certificatetype_id == uploaded_certificate.certificatetype_id})
        if(exampmatch!==-1)
        {
          exemptioncertificates[exampmatch].documents.push(uploaded_certificate)
        }

        let reqmatch = requiredcertificates.findIndex((item)=>{return item.certificatetype_id == uploaded_certificate.certificatetype_id})
        if(reqmatch!==-1)
        {
          requiredcertificates[reqmatch].documents.push(uploaded_certificate)
        }

      }

      
      for (let i = 0; i < requiredcertificates.length; i++)
      {
        for (let ii = 0; ii < requiredcertificates[i].documents.length; ii++)
        {
          if(requiredcertificates[i].documents[ii].status=="accepted")
          {
            requiredcertificates[i].upload_status = 1            
          }
        }
        
      }

      for (let i = 0; i < exemptioncertificates.length; i++)
      {
        for (let ii = 0; ii < exemptioncertificates[i].documents.length; ii++)
        {
          if(exemptioncertificates[i].documents[ii].status=="accepted")
          {
            exemptioncertificates[i].upload_status = 1            
          }
        }
      }



      this.requiredcertificates = requiredcertificates
      this.exemptioncertificates = exemptioncertificates

    },
  	async getData()
    {
      
      this.data = await this.generalApiGetWithoutLoader("audit/get_flow_summary_data/"+this.$route.params.flow_id) 
      console.log(this.data)
      await this.$store.dispatch('evaluation/setMode',"viewing")
      await this.$store.dispatch('evaluation/setEvaluation',this.data.flowsupplier) 
      if(this.data.quizresult && this.data.quizresult.questionlist)
      {
        await this.$store.dispatch('evaluation/setNullreasons',this.data.quizresult.questionlist.nullreasons)        
      }
      /*
      let supplierattributes = this.data.flowsupplier.supplier.supplierattributes
      for(let flowattribute of this.data.flowsupplier.flow.flowattributes)
      {
        let the_att = await supplierattributes.find((item)=>{return item.customattribute_id == flowattribute.customattribute_id})
        if(the_att)
        {
          await this.flowsupplierattributes.push(the_att)
        }
       
      }
      */
      
      let requiredcertificates = await []
      let exemptioncertificates = await []      
      this.nonconformities = this.data.nonconformities
      this.nonconformity_types = this.data.nonconformity_types
      
      //loop requiredcertificates
      for(let requiredcertificate of this.data.flowsupplier.flow.requiredcertificates)
      {
        let element = await requiredcertificates.find((item)=>{return item.certificatetype_id == requiredcertificate.certificatetype_id})
        if(element)
        {
          await requiredcertificates.push(requiredcertificate)
        }
      }
      //loop requiredcertificates

      //loop exemptioncertificate
      for(let exemptioncertificate of this.data.flowsupplier.flow.exemptioncertificates)
      {
        let element = await exemptioncertificates.find((item)=>{return item.certificatetype_id == exemptioncertificate.certificatetype_id})
        if(element)
        {
          await exemptioncertificates.push(exemptioncertificate)
        }
      }
      //loop exemptioncertificate

      
      

      for(let requiredcertificate of requiredcertificates)
      {
        let element = await exemptioncertificates.find((item)=>{return item.certificatetype_id == requiredcertificate.certificatetype_id })
        console.log(element)
        if(element)
        {
          requiredcertificates = await requiredcertificates.filter((item)=>{return item.certificatetype_id !== element.certificatetype_id})
        }
      }

      this.exemptioncertificates = await exemptioncertificates
      this.requiredcertificates = await requiredcertificates

      await this.resolveUploadedCertificates()


      this.loading = await false
    },
    gotoActiveFlow(uuid)
    {            
      console.log(this.data)
      if(this.data.flowsupplier.flow.type=='audit' && this.data.flowsupplier.audit) 
      {
        this.$router.push({ name: 'AuditCover', params: { audit_uuid:this.data.flowsupplier.audit.uuid } })
      }
      else
      {
        this.$router.push({ name: 'Evaluation', params: { id:uuid } })
      }
      
    },
  }
}
</script>

<style lang="css" scoped>
  #quizresult_wrap{
    background-color: #fff;
  }
</style>